module.exports = __webpack_public_path__ + "static/media/tarja-contatos.c04a3e99.jpg";